module.exports = __webpack_public_path__ + "static/Scan-Go-Mobile-Checkout-ad94df03409b3d072b2245a93bf7a41b.jpg";